<template>
    <div>
        <b-row class="m-0 px-2">
            <b-col sm="12" md="4" class="pl-0">
                <b-form-group>
                    <label for="name"><strong>Identificador *</strong></label>
                        <b-form-input
                            type="text"
                            id="name"
                            v-model="name"
                            :disabled="isSystemRole">
                        </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="m-0 px-2">
            <b-col sm="12" md="4" class="pl-0">
                <b-form-group>
                    <label for="description"><strong>Descripción *</strong></label>
                    <b-form-input
                        type="text"
                        id="description"
                        v-model="description"
                        :disabled="isSystemRole">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <hr/>

        <permission-check-list
            :allPermissions="permissions"
            :initialPermissions="initialPermissions"
            :disabledPermissions="[]"
            @emit-permission-uuids="emitRoleForm($event)">
            <slot></slot>
        </permission-check-list>
    </div>
</template>

<script>
    import PermissionCheckList from '@/components/permissions/PermissionsCheckList';

    export default {
        name: "role-form",
        props: [
            'permissions',
            'initialPermissions',
            'initialName',
            'initialDescription',
            'isSystemRole'
        ],
        components: {
            PermissionCheckList
        },
        data: function () {
            return {
                name: this.initialName,
                description: this.initialDescription
            };
        },
        methods: {
            emitRoleForm(permissionsUuids) {
                this.$emit('emit-role-form', {
                    name: this.name,
                    description: this.description,
                    permissions: permissionsUuids
                });
            }
        }
    }
</script>

<style scoped>

</style>